import { useMemo } from 'react'
import { useIntl } from 'react-intl'

interface AgeOption {
  value: number
  label: string
}

/**
 * Returns localized age options for occupancy age selection (0–17 years by default).
 * This hook should be used instead of the deprecated AGE_OPTIONS constant in constants/search.ts.
 */
function useAgeOptions(maxAge = 17): Array<AgeOption> {
  const intl = useIntl()

  return useMemo(() => (
    Array.from({ length: maxAge + 1 }, (_, age) => ({
      value: age,
      label: age === 0 ?
          intl.formatMessage({
            id: 'Osyhj0ZmWoXd80owpJt0',
            defaultMessage: '0-1 year',
          }) :
          intl.formatMessage(
            {
              id: 'MJX9xHFr07yQ3yDdEbdh',
              defaultMessage: '{age, plural, one {# year} other {# years}}',
            },
            { age },
          ),
    }))
  ), [intl, maxAge])
}

export default useAgeOptions
